import { walletApiSlice } from '../apiSlice';

interface IGetCreditUsageLogsRequest {
	walletId: string;
	pageNumber?: number;
	pageSize?: number;
	fromDate?: string;
	toDate?: string;
	status?: string | null;
	serviceType?: string;
}

export interface IValidateCreditRequest {
	walletId: string;
	serviceType: string;
	unitsRequested: number;
}

export interface IValidateCreditResponse {
	walletId: string;
	serviceType: string;
	unitsRequested: number;
	hasEnoughCredit: boolean;
	unitsProcessable: number;
	unitShortfall: number;
	creditCostPerUnit: number;
	creditsRequired: number;
	availableCredits: number;
	creditsProcessable: number;
	creditShortfall: number;
}

export const walletUsageApiSlice = walletApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getCreditUsageLogs: builder.mutation<unknown, IGetCreditUsageLogsRequest>({
			query: (body) => ({
				url: '/usage/logs',
				method: 'POST',
				body,
			}),
		}),
		validateWalletCredit: builder.mutation<IValidateCreditResponse, IValidateCreditRequest>({
			query: (body) => ({
				url: '/usage/validate',
				method: 'POST',
				body,
			}),
		}),
	}),
});

export const { useGetCreditUsageLogsMutation, useValidateWalletCreditMutation } = walletUsageApiSlice;
